import { Controller } from 'stimulus';
import $ from 'jquery';

class VideoModal extends Controller {
  initialize() {
    // modal elements
    this.modal = $(this.modalIdValue);
    this.modalBody = this.modal.find('#body');
  }

  openModal() {
    this.modalBody.html(this.videoUrlValue);

    const iframe = this.modal.find('iframe');
    const close_button = this.modal.find('button#close-button');
    close_button.on('click', () => {
      console.log('closing');
      iframe.attr('src', '');
    });

    this.modal.attr('data-modal-open-value', true);
  }
}

VideoModal.targets = [];
VideoModal.values = {
  videoUrl: String,
  modalId: String,
};

export default VideoModal;